import { AvailableResources } from './types';

export const resourceConfig: Record<string, { path: string }> = {
  [AvailableResources.CYCLES]: {
    path: 'cycles'
  },
  [AvailableResources.SIMPLIFIED_CYCLES]: {
    path: 'cycles/simplified'
  },
  [AvailableResources.PRODUCTION_PLAN_ALLOCATIONS]: {
    path: 'production-plan-allocations/filtered'
  },
  [AvailableResources.PRODUCTION_PLAN_ALLOCATION_OPTIONS]: {
    path: 'production-plan-allocations/allocation-options'
  },
  [AvailableResources.VARIETIES]: {
    path: 'varieties/remaining-allocations/filtered'
  },
  [AvailableResources.VARIETY_ALLOCATIONS]: {
    path: 'variety-allocations'
  },
  [AvailableResources.VARIETY_ALLOCATIONS_BATCH]: {
    path: 'variety-allocations/batch'
  },
  [AvailableResources.VARIETY_ALLOCATIONS_PUBLISH]: {
    path: 'variety-allocations/publish'
  },
  [AvailableResources.VARIETY_ALLOCATIONS_SPLIT]: {
    path: 'variety-allocations/split'
  },
  [AvailableResources.SIMPLIFIED_PLANTING_INSTRUCTIONS]: {
    path: 'simplified-planting-instructions'
  },
  [AvailableResources.PRODUCTION_PLAN_VERSIONS]: {
    path: 'production-plan-versions'
  },
  [AvailableResources.CROPS]: {
    path: 'planning-crops'
  },
  [AvailableResources.CYCLE_FIELDS_ALLOCATIONS]: {
    path: 'cycle-field-allocations/filtered'
  },
  [AvailableResources.CYCLE_FIELDS]: {
    path: 'cycle-fields'
  },
  [AvailableResources.GROWERS]: {
    path: 'planning-growers'
  },
  [AvailableResources.GROWERS_LIST]: {
    path: 'planning-growers/filtered'
  },
  [AvailableResources.GROWING_AREAS]: {
    path: 'growing-areas'
  },
  [AvailableResources.GROWING_AREAS_MANAGEMENT]: {
    path: 'growing-areas/management'
  },
  [AvailableResources.GROWING_AREAS_CROPWISE_ORGS]: {
    path: 'growing-areas/cropwise-orgs'
  },
  [AvailableResources.GROWING_AREA_PROPERTIES]: {
    path: 'planning-properties'
  },
  [AvailableResources.PROPERTY_FIELDS]: {
    path: 'planning-fields'
  },
  // One endpoint, two verbs: POST adds fields to a season, PUT edits the ones
  // already in it.
  [AvailableResources.CYCLE_FIELDS_BATCH]: {
    path: 'cycle-fields/batch'
  },
  [AvailableResources.PRODUCTION_ORDERS]: {
    path: 'production-orders/filtered'
  },
  [AvailableResources.VARIETY_DEVIATIONS]: {
    path: 'variety-deviations'
  },
  [AvailableResources.REGIONS]: {
    path: 'regions'
  },
  [AvailableResources.STORAGE_LOCATIONS]: {
    path: 'storage-locations'
  },
  [AvailableResources.RATIOS]: {
    path: 'regions/ratios'
  },
  [AvailableResources.PRODUCTION_ORDERS_BATCH]: {
    path: 'production-orders/batch'
  },
  [AvailableResources.PRODUCTION_ORDERS_CANCEL]: {
    path: 'production-orders/cancel'
  },
  [AvailableResources.PRODUCTION_ORDERS_LIST_EXPORT]: {
    path: 'production-orders/export-list'
  },
  [AvailableResources.PRODUCTION_PLANTS]: {
    path: 'production-plants'
  },
  [AvailableResources.STORAGE_WAREHOUSES]: {
    path: 'storage-warehouses'
  },
  [AvailableResources.WORKERS]: {
    path: 'workers'
  },
  [AvailableResources.WORKERS_SIMPLIFIED]: {
    path: 'workers/simplified'
  },
  [AvailableResources.WORKERS_LIST]: {
    path: 'workers/filtered'
  },
  [AvailableResources.MERGE_PRODUCTION_ORDERS]: {
    path: 'production-orders/merge'
  },
  [AvailableResources.CUSTOM_DATA_ELEMENTS]: {
    path: 'custom-data-elements'
  },
  [AvailableResources.PARENT_SEED_ATTRIBUTES]: {
    path: 'parent-seeds-attributes'
  },
  [AvailableResources.PARENT_SEEDS_ASSIGNMENTS]: {
    path: 'parent-seeds-assignments/filtered'
  },
  [AvailableResources.PARENT_SEEDS_ASSIGNMENTS_BATCH]: {
    path: 'parent-seeds-assignments/batch'
  },
  [AvailableResources.PARENT_SEEDS_ASSIGNMENTS_SUMMARY]: {
    path: 'parent-seeds-assignments'
  },
  [AvailableResources.HYBRID_PARENT_SEEDS_ASSIGNMENTS]: {
    path: 'hybrid-parent-seeds-assignments/filtered'
  },
  [AvailableResources.HYBRID_PARENT_SEEDS_ASSIGNMENTS_BULK]: {
    path: 'hybrid-parent-seeds-assignments/bulk'
  },
  [AvailableResources.HYBRID_PARENT_SEEDS_ASSIGNMENTS_CALCULATE]: {
    path: 'hybrid-parent-seeds-assignments/calculate'
  },
  [AvailableResources.HYBRID_PARENT_SEEDS_ASSIGNMENTS_FILTER_OPTIONS]: {
    path: 'hybrid-parent-seeds-assignments/filter-options'
  },
  [AvailableResources.HYBRID_PARENT_SEEDS_SUMMARY]: {
    path: 'hybrid-parent-seeds-assignments/summary/filtered'
  },
  [AvailableResources.PARENT_SEEDS_BATCH_ASSIGNMENT_INVENTORIES_LAST_EXECUTION]:
    {
      path: 'parent-seeds-batch-assignment-inventories/last-execution'
    },
  [AvailableResources.HYBRID_EXPORT_BATCHES]: {
    path: 'hybrid-parent-seeds-assignments/export-batches/filtered'
  },
  [AvailableResources.HYBRID_EXPORT_BATCHES_BULK]: {
    path: 'hybrid-parent-seeds-assignments/export'
  },
  [AvailableResources.HYBRID_EXPORT_BATCHES_VALIDATE]: {
    path: 'hybrid-parent-seeds-assignments/export/validate'
  },
  [AvailableResources.EXPORT_BATCHES]: {
    path: 'parent-seeds-batches/filtered'
  },
  [AvailableResources.EXPORT_BATCHES_BULK]: {
    path: 'parent-seeds-batches/export'
  },
  [AvailableResources.PARENT_SEEDS_BATCHES]: {
    path: 'parent-seeds-batches'
  },
  [AvailableResources.PLANTING_INSTRUCTIONS_FILTERED]: {
    path: 'planting-instructions/filtered'
  },
  [AvailableResources.PLANTING_INSTRUCTIONS_UPLOAD]: {
    path: 'planting-instructions/upload'
  },
  [AvailableResources.PLANTING_INSTRUCTIONS_TEMPLATE_DOWNLOAD]: {
    path: 'planting-instructions/template/download'
  },
  [AvailableResources.PLANTING_INSTRUCTIONS_FIELD_KEYS]: {
    path: 'planting-instructions/field-keys'
  },
  [AvailableResources.PLANTING_INSTRUCTIONS_TEMPLATES]: {
    path: 'planting-instruction-templates'
  },
  [AvailableResources.ISOLATION_AREAS]: {
    path: 'isolation-areas'
  },
  [AvailableResources.PRODUCTION_PLAN_ALLOCATIONS_EXPORT]: {
    path: 'production-plan-allocations/export'
  },
  [AvailableResources.PLANNING_DATA_IMPORT]: {
    path: 'planning-data/import'
  },
  [AvailableResources.PLANNING_DATA_IMPORT_LOGS]: {
    path: 'planning-data/import/logs'
  },
  [AvailableResources.PLANNING_DATA_IMPORT_TEMPLATE]: {
    path: 'planning-data/import/template'
  },
  [AvailableResources.PLANNING_DATA_IMPORT_USERS]: {
    path: 'planning-data/import/users'
  },
  [AvailableResources.CROPWISE_INTEGRATION_ALLOCATIONS]: {
    path: 'cropwise-integrations/allocations/filtered'
  },
  [AvailableResources.CROPWISE_INTEGRATION_PREVIEW]: {
    path: 'cropwise-integrations/allocations/integration-preview'
  },
  [AvailableResources.CROPWISE_INTEGRATION_PLANTING_INSTRUCTIONS]: {
    path: 'cropwise-integrations/planting-instructions/filtered'
  },
  [AvailableResources.TASKS]: {
    path: 'tasks'
  }
};
